import React, { Component, createRef } from "react";
import NewsletterForm from "../../../Newsletter/NewsletterForm";

interface State {
  firingConfetti: boolean;
  subscribed: boolean;
}

class Subscription extends Component<{}, State> {
  confettiCanvasRef = createRef<HTMLCanvasElement>();
  unmounted = false;

  state: State = {
    firingConfetti: false,
    subscribed: false,
  };

  componentWillUnmount() {
    this.unmounted = true;
  }

  onSubscribed = () => {
    this.setState({ subscribed: true }, this.fireConfetti);
  };

  fireConfetti = () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const canvas = this.confettiCanvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    if (!context) return;

    const ratio = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * ratio;
    canvas.height = window.innerHeight * ratio;
    context.setTransform(ratio, 0, 0, ratio, 0, 0);

    const colours = [
      "#233dff",
      "#FF645E",
      "#F5B041",
      "#16a34a",
      "#2E2437",
      "#F3EC7A",
      "#B798F2",
    ];
    const pieces = Array.from({ length: 150 }).map(() => ({
      x: window.innerWidth / 2,
      y: window.innerHeight * 0.35,
      vx: (Math.random() - 0.5) * 12,
      vy: Math.random() * -10 - 4,
      size: Math.random() * 7 + 4,
      rotate: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.25,
      colour: colours[Math.floor(Math.random() * colours.length)],
      life: 90 + Math.random() * 30,
    }));

    this.setState({ firingConfetti: true });

    const tick = () => {
      context.clearRect(0, 0, window.innerWidth, window.innerHeight);

      pieces.forEach((piece) => {
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.vy += 0.28;
        piece.rotate += piece.vr;
        piece.life -= 1;

        if (piece.life <= 0) return;

        context.save();
        context.translate(piece.x, piece.y);
        context.rotate(piece.rotate);
        context.fillStyle = piece.colour;
        context.fillRect(
          -piece.size / 2,
          -piece.size / 2,
          piece.size,
          piece.size * 0.6,
        );
        context.restore();
      });

      if (pieces.some((piece) => piece.life > 0)) {
        requestAnimationFrame(tick);
      } else {
        context.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (!this.unmounted) {
          this.setState({ firingConfetti: false });
        }
      }
    };

    requestAnimationFrame(tick);
  };

  renderNewsletterBlobs = () => (
    <svg
      className="newsletter-blobs"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1200 600"
      xmlns="http://www.w3.org/2000/svg"
    >
      <use
        href="#blob-1"
        transform="translate(120, 140) scale(1.12)"
        fill="#2E2437"
        opacity="0.06"
      ></use>
      <use
        href="#blob-1"
        transform="translate(1050, 460) scale(1.4)"
        fill="#2E2437"
        opacity="0.05"
      ></use>
    </svg>
  );

  render() {
    return (
      <section
        className={`newsletter ${this.state.subscribed ? "is-submitted" : ""}`}
        aria-label="Newsletter signup"
      >
        {this.renderNewsletterBlobs()}
        <div className="inner">
          <NewsletterForm onSubscribed={this.onSubscribed} />
        </div>
        <canvas
          ref={this.confettiCanvasRef}
          className={`newsletter-confetti ${
            this.state.firingConfetti ? "firing" : ""
          }`}
          aria-hidden="true"
        />
      </section>
    );
  }
}

export default Subscription;
